<template>
  <header class="configurer-header sticky-top">
    <div class="logo-section">
      <h4 class="m-0 font-weight-bold" style="color: #007D53; cursor: pointer;" @click="$router.push('/configure/user/customize').catch(()=>{})">
        MSDAT Configurer
      </h4>
    </div>

    <div class="auth-section">
      <b-dropdown right variant="link" toggle-class="text-decoration-none dropdown-toggle-no-caret p-0" no-caret v-if="isAuthenticated">
        <template #button-content>
          <div class="profile-icon">
            <b-icon icon="person-circle" font-scale="2" style="color: #007D53;"></b-icon>
          </div>
        </template>
        <b-dropdown-header>
          {{ currentUser?.email || 'User' }}
        </b-dropdown-header>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="$router.push('/configure/user/profile').catch(()=>{})">
          <b-icon icon="grid-fill" class="mr-2"></b-icon> My Dashboards
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="handleLogout">
          <b-icon icon="box-arrow-right" class="mr-2"></b-icon> Logout
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ConfigurerHeader',
  computed: {
    ...mapGetters('configurerAuth', ['isAuthenticated', 'currentUser']),
  },
  methods: {
    ...mapActions('configurerAuth', ['logout']),
    async handleLogout() {
      await this.logout();
      this.$router.push('/configure/account');
    },
  },
};
</script>

<style scoped>
.configurer-header {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  z-index: 1000;
}

.profile-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.profile-icon:hover {
  transform: scale(1.05);
}

.dropdown-toggle-no-caret::after {
  display: none !important;
}
</style>
